export const Role = {
  SuperAdmin: "Super Admin",
  HoManager: "HO Manager",
  CinemaManager: "Cinema Manager",
  PosOperator: "POS Operator", // PosOperator: 'POS Operator',
  PosFnBOperator: "FnB POS Operator",
  Distributor: "Distributor",
  BoxOfficeFnbOperator: "Box Office Fnb",
  AnalyticsManager: "Analytics Manager",
  KitchenManager: "Kitchen Manager",
  ProgrammingManager: "Programming Manager",
};

export const CLIENT_NAME = {
  CINEMA_AKIL: "Cinema Akil",
  EMPIRE: "empire",
  STUESSIHOF: "stuessihof",
  XANADU: "xanadu",
  PETRO: "petro",
  IRAQ: "Iraq",
  LEBANON: "lebanon",
  BILDHAUS: "bildhaus",
  QFX: "qfx",
  STAR: "starcinemas",
  CINEPOLIS_OMAN: "cinepolis-oman",
  WOW: "wow",
  DOODLES: "doodles",
  EPIX: "epix",
  REELCINEMAS: "reelcinemas",
  EGYT_MIF: "mif",
  PLAYCINEMAS: "playcinema",
  PLATINUM: "platinum",
};

export const CLIENT_NAMES_OBJ = {
  empire_combo: ["empire", "petro", "Iraq", "starcinemas", "lebanon"],
  empire_iraq: ["empire", "Iraq"],
  multiple_ticket_clients: ["bildhaus", "carnival"],
  empire_iraq_lebanon: ["empire", "Iraq", "lebanon"],
  empire_clients: ["empire", "Iraq", "lebanon", "petro"],
  iraq: ["Iraq"],
  empire: ["empire"],
  xanadu: ["xanadu"],
  petro: ["petro"],
  stuessihof: ["stuessihof"],
  lebanon: ["lebanon"],
  bildhaus: ["bildhaus"],
  qfx: ["qfx"],
  star: ["starcinemas"],
  star_ticket_clients: ["starcinemas", "reelcinemas"],
  reelcinemas: ["reelcinemas"],
  carnival: ["carnival"],
  wow: ["wow"],
  oman_ticket_clients: ["cinepolis-oman", "wow"],
  bildhaus_qfx: ["bildhaus", "qfx"],
  BrijEurope: ["Brij Europe"],
  qfxcinepolis: ["qfx", "cinepolis-oman"],
  cinepolis: ["cinepolis-oman"],
  has_delivery_stations: ["starcinemas", "empire", "cinepolis-oman", "epix"],
  no_login_print: ["qfx", "cinepolis-oman"],
  WOW: ["wow"],
  epix: ["epix"],
  cash_shift_receipt: ["qfx", "cinepolis-oman"],
  trx_comment_mandatory: ["epix", "Cinema Akil"],
  secondary_cash_calculator: ["lebanon"],
  show_print_on_kitchen_display: ["epix", "starcinemas"],
  single_api_tickets: ["mif", "platinum"],
  manualCardCheckoutClients: ["wow", "epix"],
  delivery_print_clients: ["starcinemas"],
  playcinema: ["playcinema"],
  enable_sync_dual_display: ["epix", "qfx"],
  platinum: ["platinum"],
};



// WEBPACK FOOTER //
// ./src/helper/Role.js